/**
 * Whether the main nav collapses into a single current-page dropdown instead of
 * the full tab row. With report tabs open the decision is a fixed viewport
 * breakpoint (the report +N overflow absorbs the squeeze above it); with no
 * reports it is a live fit measurement of the expanded tabs against the space
 * they actually have. Pure so it can be unit-tested without a layout engine.
 */
export const computeNavCollapsed = (
  hasReports: boolean,
  wideEnoughForFullNav: boolean,
  fitsExpanded: boolean,
): boolean => (hasReports ? !wideEnoughForFullNav : !fitsExpanded);
